import { SegmentScript as Script } from '@calendly/segment'
import { useSelector } from 'react-redux'

import Settings from 'core/settings'
import { isCookiesAllowedSelector } from 'selectors/gdpr'

export const SegmentScript = () => {
  const isAllowed = useSelector(isCookiesAllowedSelector('performance'))
  const isActive = Settings.segment.enabled && isAllowed

  return (
    <Script active={isActive} clientWriteKey={Settings.segment.client_write_key} />
  )
}
